import * as React from "react";
import {Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import {ReactElement} from "react";

interface IConfirmationDialogProps {
	button?: ReactElement|undefined;
	buttonTitle: ReactElement|string;
	dialogTitle: string;
	onSuccess: () => void;
	onCancel?: () => void;
	successTitle?: string;
	cancelTitle?: string;
	dialogDescription?: string;
	buttonProps?: { loading?: boolean } & ButtonProps;
	open?: boolean;
	
}

export const ConfirmationDialog: React.FC<IConfirmationDialogProps> = (props) => {
	const [open, setOpen] = React.useState(props.open??false);
	
	const handleClickOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};
	
	const onCancel = () => {
		if (props.onCancel) {
			props.onCancel();
		}
		
		handleClose();
	};
	
	const onSuccess = () => {
		props.onSuccess();
		handleClose();
	};
	
	return (
		<div>
			<LoadingButton {...props.buttonProps} onClick={handleClickOpen}>
				{props.buttonTitle}
			</LoadingButton>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{props.dialogTitle}
				</DialogTitle>
				{props.dialogDescription &&
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{props.dialogDescription}
						</DialogContentText>
					</DialogContent>
				}
				<DialogActions>
					<Button color={"error"} onClick={onCancel}>{props.cancelTitle ?? "Cancel"}</Button>
					<Button variant={"outlined"} onClick={onSuccess} autoFocus>{props.successTitle ?? "Confirm"}</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
